import React from "react";

import PolicyForm from "../../../../PolicyPlans/Form";

import { useContext } from "../../Context";

export default function Edit({ plan, onCancel }) {
  const { dispatch, actions, state } = useContext();

  const onSave = (values, onError) => {
    actions.updatePlan(
      dispatch,
      state.enterpriseId,
      plan.id,
      values,
      () => {
        actions.load(dispatch, state.enterpriseId);
      },
      (errors) => {
        onError(errors);
      }
    );
  };

  const onCancelHandler = () => {
    onCancel();
  };

  return (
    <PolicyForm
      onSubmit={onSave}
      onCancel={onCancelHandler}
      typeView="policy"
      template={plan}
    />
  );
}
